import { useParams } from "react-router-dom";
import NewAgentPage from "./new-agent";

export const EditAgentPage = () => {
  const { id } = useParams();

  return <NewAgentPage agentId={id} />;
};
